var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicFolderLight255(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 255,
    viewBox: "0 0 255 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_795_1457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.5 212.495C174.441 212.495 212.495 174.441 212.495 127.5C212.495 80.5588 174.441 42.5053 127.5 42.5053C80.5588 42.5053 42.5054 80.5588 42.5054 127.5C42.5054 174.441 80.5588 212.495 127.5 212.495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.812,
    cy: 84.4688,
    r: 37.25,
    fill: "#F2F2F2",
    stroke: "#B3B3B3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.719 73.3762C133.378 73.3762 135.533 71.2213 135.533 68.5631C135.533 65.9049 133.378 63.75 130.719 63.75C128.061 63.75 125.906 65.9049 125.906 68.5631C125.906 71.2213 128.061 73.3762 130.719 73.3762Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.994 160.395C236.477 160.395 238.489 158.383 238.489 155.901C238.489 153.418 236.477 151.406 233.994 151.406C231.512 151.406 229.5 153.418 229.5 155.901C229.5 158.383 231.512 160.395 233.994 160.395Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.145 124.312L174.149 132.775H164.156L169.161 124.312H169.145Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0356 44.625V54.6178M53.04 49.6294H43.0312",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.703 81.6665H216.75V87.3994H203.703V100.406H197.895V87.3994H184.875V81.6665H197.895V68.5312H203.703V81.6665Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81 165.622C113.81 171.009 109.443 175.36 104.072 175.36H21.1011C15.7142 175.36 11.3633 170.993 11.3633 165.622V104.901C11.3633 99.5137 15.7302 95.1628 21.1011 95.1628H45.4695L55.2073 102.287H104.072C109.459 102.287 113.81 106.654 113.81 112.025V165.622Z",
    stroke: "#B3B3B3",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7988 156.187C54.9831 156.187 69.6636 156.187 95.8479 156.187M28.7988 145.924H95.8479M28.7988 135.644H95.8479M28.7988 120.153H50.7448",
    stroke: "#0078D7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.43 181.911H150.02V178.5C150.02 177.623 149.303 176.906 148.426 176.906C147.549 176.906 146.832 177.623 146.832 178.5V181.911H143.438C142.561 181.911 141.844 182.628 141.844 183.504C141.844 184.381 142.561 185.098 143.438 185.098H146.848V188.509C146.848 189.385 147.565 190.102 148.442 190.102C149.318 190.102 150.036 189.385 150.036 188.509V185.098H153.446C154.323 185.098 155.04 184.381 155.04 183.504C155.04 182.628 154.323 181.911 153.446 181.911H153.43Z",
    fill: "#0078D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_795_1457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 255,
    height: 255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicFolderLight255);
export default __webpack_public_path__ + "static/media/graphic_folder-light-255.2dd327dc37e167ff99f4276e6651816a.svg";
export { ForwardRef as ReactComponent };